import Component from '../abstracts/Component';

export default class CollapseComponent extends Component {

  get COMPONENTNAME() {
    return 'CollapseComponent';
  }

  get SELECTORS() {
    return {
      trigger: '[data-trigger]',
      tab: '[data-tab]',
      button: '[data-collapsable-button]',
    };
  }

  get CLASSES() {
    return {
      collapsed: 'collapsed'
    }
  }

  constructor(compEl) {
    super(compEl);
  }

  readDOM() {
    return {
      triggers: this.$component.querySelectorAll(this.SELECTORS.trigger),
      tabs: this.$component.querySelectorAll(this.SELECTORS.tab),
      currentOpenTab: null,
    };
  }

  //get all the tabs and set the height
  init() {
    if(this.dom.tabs) {
      this.dom.tabs.forEach(tab => {
        tab.style.height = tab.offsetHeight + "px";
      });
    }
    if(this.dom.triggers) {
      this.dom.triggers.forEach(trigger => {
        if(trigger.dataset.trigger === "start-open") {
          this.dom.currentOpenTab = trigger;
          this.setTabVisibility(trigger, true);
        } else {
          trigger.classList.add(this.CLASSES.collapsed);
          this.setTabVisibility(trigger, false);
        }
      });
    }
  }

  //handle click on trigger element
  handleCollapse() {
    if(this.dom.triggers) {
      this.dom.triggers.forEach(trigger => {
        trigger.addEventListener("click", () => {
          if(this.dom.currentOpenTab === trigger) {
            // click on the same trigger to close the section
            trigger.classList.add(this.CLASSES.collapsed);
            trigger.querySelector(this.SELECTORS.button)?.setAttribute("aria-expanded","false");
            this.setTabVisibility(trigger, false);
            this.dom.currentOpenTab = null;
          } else if(this.dom.currentOpenTab != null) {
            //another tab is currently open
            this.dom.currentOpenTab.classList.add(this.CLASSES.collapsed);
            this.dom.currentOpenTab.querySelector(this.SELECTORS.button)?.setAttribute("aria-expanded","false");
            this.setTabVisibility(this.dom.currentOpenTab, false);
            trigger.classList.remove(this.CLASSES.collapsed);
            trigger.querySelector(this.SELECTORS.button)?.setAttribute("aria-expanded","true");
            this.setTabVisibility(trigger, true);
            this.dom.currentOpenTab = trigger;
          } else {
            //is the first trigger clicked
            trigger.classList.remove(this.CLASSES.collapsed);
            trigger.querySelector(this.SELECTORS.button)?.setAttribute("aria-expanded","true");
            this.setTabVisibility(trigger, true);
            this.dom.currentOpenTab = trigger;
          }
        });
      });
    }
  }

  //set visibility for keyboard navigation
  setTabVisibility(trigger, isVisible) {
    const tabContent = trigger.parentNode.querySelector(this.SELECTORS.tab);
    if (tabContent) {
      // Only apply visibility: hidden for components that need keyboard accessibility
      // Exclude splash page country selectors which have their own CSS handling
      const isSplashCountrySelector = tabContent.closest('.s-p__continent');
      
      if (!isSplashCountrySelector) {
        tabContent.style.visibility = isVisible ? 'visible' : 'hidden';
      }
    }
  }

  bindEvents() {
    this.handleCollapse();
    window.addEventListener('resize', () => {
      if (this.dom.currentOpenTab) {
        const tab = this.dom.currentOpenTab.parentNode.querySelector(this.SELECTORS.tab);
        tab.style.maxHeight = tab.scrollHeight + "px";
      }
    });
  }

  render() {
    super.render();
    this.log('Rendering...');
    this.dom = this.readDOM();
    this.init();
    this.bindEvents();
  }
}
